module.exports = __webpack_public_path__ + "img/loading.264a08a0.gif";